import React, { createContext, useContext, useState,useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem("token"));
    const [user, setUser] = useState("");


    const storeTokenInLS = (serverToken) => {
        setToken(serverToken);
        localStorage.setItem('token', serverToken);
    };
    let isLoggedIn = !!token;

    const LogoutUser = () => {
        setToken("");
        return localStorage.removeItem("token");
    };
    const getUserData = async () => {
        try {
            const response = await fetch("http://localhost:3001/api/auth/user",
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if(response.ok){
                   const data=await response.json();
                   setUser(data.userData);   
                   console.log(data.userData);
                }
        } catch (error) {
            console.log("Error", error);
        }
    }
    useEffect(() => {
        getUserData()
    }, [])
    return (
        <AuthContext.Provider value={{ isLoggedIn, storeTokenInLS, LogoutUser,user }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const authContextValue = useContext(AuthContext);
    if (!authContextValue) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return authContextValue;
};
